import { User } from "@core/domains/identity";
import { api, apiEndpoint } from "@core/ports/http";
import { z } from "@core/zod";

import { API_DOMAIN } from "@platform/core";

import { ACCOUNT_SERVICE } from "../config/index.ts";

export const accountApi = api(
  { domain: API_DOMAIN, path: `${ACCOUNT_SERVICE.LABEL}/api` },
  {
    getMe: apiEndpoint({
      response: z.object({ user: User.schema }, { user: "The signed-in user" }),
    }),
    updateMe: apiEndpoint({
      body: z.object(
        { update: User.updateSchema },
        { update: "The changes to apply to the signed-in user" },
      ),
      response: z.object(
        { user: User.schema },
        { user: "The signed-in user, with the changes applied" },
      ),
    }),
  },
);
